/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { OperationsTaskType } from "./OperationsTaskType";
import {
  OperationsTaskTypeFromJSON,
  OperationsTaskTypeFromJSONTyped,
  OperationsTaskTypeToJSON,
  OperationsTaskTypeToJSONTyped,
} from "./OperationsTaskType";
import type { ConversationTurn } from "./ConversationTurn";
import {
  ConversationTurnFromJSON,
  ConversationTurnFromJSONTyped,
  ConversationTurnToJSON,
  ConversationTurnToJSONTyped,
} from "./ConversationTurn";
import type { OperationsTaskResolutionChannel } from "./OperationsTaskResolutionChannel";
import {
  OperationsTaskResolutionChannelFromJSON,
  OperationsTaskResolutionChannelFromJSONTyped,
  OperationsTaskResolutionChannelToJSON,
  OperationsTaskResolutionChannelToJSONTyped,
} from "./OperationsTaskResolutionChannel";

/**
 *
 * @export
 * @interface OperationsTaskDetails
 */
export interface OperationsTaskDetails {
  /**
   *
   * @type {string}
   * @memberof OperationsTaskDetails
   */
  operationsTaskId: string;
  /**
   *
   * @type {OperationsTaskType}
   * @memberof OperationsTaskDetails
   */
  operationsTaskType: OperationsTaskType;
  /**
   *
   * @type {boolean}
   * @memberof OperationsTaskDetails
   */
  isDone: boolean;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OperationsTaskDetails
   */
  updatedAt?: OffsetDateTime | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OperationsTaskDetails
   */
  createdAt: OffsetDateTime;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof OperationsTaskDetails
   */
  closedAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof OperationsTaskDetails
   */
  title?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof OperationsTaskDetails
   */
  monitoring: boolean;
  /**
   *
   * @type {ConversationTurn}
   * @memberof OperationsTaskDetails
   */
  customerConversationTurn?: ConversationTurn | null;
  /**
   *
   * @type {ConversationTurn}
   * @memberof OperationsTaskDetails
   */
  carrierConversationTurn?: ConversationTurn | null;
  /**
   *
   * @type {string}
   * @memberof OperationsTaskDetails
   */
  description?: string | null;
  /**
   *
   * @type {number}
   * @memberof OperationsTaskDetails
   */
  timesOpened: number;
  /**
   *
   * @type {OperationsTaskResolutionChannel}
   * @memberof OperationsTaskDetails
   */
  resolutionChannel?: OperationsTaskResolutionChannel | null;
  /**
   *
   * @type {string}
   * @memberof OperationsTaskDetails
   */
  resolutionDetail?: string | null;
}

/**
 * Check if a given object implements the OperationsTaskDetails interface.
 */
export function instanceOfOperationsTaskDetails(
  value: object,
): value is OperationsTaskDetails {
  if (!("operationsTaskId" in value) || value["operationsTaskId"] === undefined)
    return false;
  if (
    !("operationsTaskType" in value) ||
    value["operationsTaskType"] === undefined
  )
    return false;
  if (!("isDone" in value) || value["isDone"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  if (!("monitoring" in value) || value["monitoring"] === undefined)
    return false;
  if (!("timesOpened" in value) || value["timesOpened"] === undefined)
    return false;
  return true;
}

export function OperationsTaskDetailsFromJSON(
  json: any,
): OperationsTaskDetails {
  return OperationsTaskDetailsFromJSONTyped(json, false);
}

export function OperationsTaskDetailsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): OperationsTaskDetails {
  if (json == null) {
    return json;
  }
  return {
    operationsTaskId: json["operationsTaskId"],
    operationsTaskType: OperationsTaskTypeFromJSON(json["operationsTaskType"]),
    isDone: json["isDone"],
    updatedAt: json["updatedAt"] == null ? undefined : json["updatedAt"],
    createdAt: json["createdAt"],
    closedAt: json["closedAt"] == null ? undefined : json["closedAt"],
    title: json["title"] == null ? undefined : json["title"],
    monitoring: json["monitoring"],
    customerConversationTurn:
      json["customerConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["customerConversationTurn"]),
    carrierConversationTurn:
      json["carrierConversationTurn"] == null
        ? undefined
        : ConversationTurnFromJSON(json["carrierConversationTurn"]),
    description: json["description"] == null ? undefined : json["description"],
    timesOpened: json["timesOpened"],
    resolutionChannel:
      json["resolutionChannel"] == null
        ? undefined
        : OperationsTaskResolutionChannelFromJSON(json["resolutionChannel"]),
    resolutionDetail:
      json["resolutionDetail"] == null ? undefined : json["resolutionDetail"],
  };
}

export function OperationsTaskDetailsToJSON(json: any): OperationsTaskDetails {
  return OperationsTaskDetailsToJSONTyped(json, false);
}

export function OperationsTaskDetailsToJSONTyped(
  value?: OperationsTaskDetails | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    operationsTaskId: value["operationsTaskId"],
    operationsTaskType: OperationsTaskTypeToJSON(value["operationsTaskType"]),
    isDone: value["isDone"],
    updatedAt: value["updatedAt"],
    createdAt: value["createdAt"],
    closedAt: value["closedAt"],
    title: value["title"],
    monitoring: value["monitoring"],
    customerConversationTurn: ConversationTurnToJSON(
      value["customerConversationTurn"],
    ),
    carrierConversationTurn: ConversationTurnToJSON(
      value["carrierConversationTurn"],
    ),
    description: value["description"],
    timesOpened: value["timesOpened"],
    resolutionChannel: OperationsTaskResolutionChannelToJSON(
      value["resolutionChannel"],
    ),
    resolutionDetail: value["resolutionDetail"],
  };
}
